import React from "react";
import AdminNavbar from "../components/Navbars/AdminNavbar";
import AdminFooter from "../components/Footers/AdminFooter";
import { Container } from "reactstrap";
import AdminSidebar from "../components/Sidebar/AdminSidebar";

const AdminLayout = (props) => {
  return (
    <>
      <AdminSidebar />
      <div className="main-content">
        <AdminNavbar name={props.name} />
        {props.children}
        <Container fluid>
          <AdminFooter />
        </Container>
      </div>
    </>
  );
};

export default AdminLayout;
